import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import './Card.scss';
import Photo from "../components/photo/Photo";
import Title from "../components/title/Title";
import Remark from "../components/remark/Remark";
import Text from '@hfe/max-text';
import Privilege from "../components/privilege/Privilege";
import Button from "../components/button/Button";
import { buildReportData } from "../utils/report";
import { onNavigate } from '../utils/navigate';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
import { BID } from '../const/bid';
function Card(p) {
    var _a, _b;
    const ctx = useMonitorEngineContext();
    const jumpToPage = (cardProps, systemInfo) => {
        var _a, _b, _c, _d, _e, _f, _g;
        (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mcReport) === null || _b === void 0 ? void 0 : _b.call(_a, BID.CARD_MC, {
            valLab: buildReportData(cardProps)
        });
        const product = {
            productType: cardProps.productType,
            productIdStr: cardProps.productIdStr,
            extInfo: cardProps.extInfo
        };
        const query = {
            hotelchannel: (_e = (_d = (_c = ctx === null || ctx === void 0 ? void 0 : ctx._runtimeInfo) === null || _c === void 0 ? void 0 : _c.queryParams) === null || _d === void 0 ? void 0 : _d.hotelchannel) !== null && _e !== void 0 ? _e : '-999'
        };
        onNavigate(product, query, systemInfo !== null && systemInfo !== void 0 ? systemInfo : {}, (_f = cardProps === null || cardProps === void 0 ? void 0 : cardProps.poiIdListString) !== null && _f !== void 0 ? _f : '', (_g = cardProps === null || cardProps === void 0 ? void 0 : cardProps.poiIdUrlExtraParamsString) !== null && _g !== void 0 ? _g : '');
    };
    // 判断是否应该展示角标
    const shouldShowTopTag = !!(p.topTagText && (p.topTagShowCount === 0 || ((_a = p.cardIndex) !== null && _a !== void 0 ? _a : 0) < ((_b = p.topTagShowCount) !== null && _b !== void 0 ? _b : 0)));
    return <View className="card-container" onAppear={() => {
            var _a, _b;
            (_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mvReport) === null || _b === void 0 ? void 0 : _b.call(_a, BID.CARD_MV, {
                valLab: buildReportData(p)
            });
        }} onClick={() => jumpToPage(p, {})}>
      <Photo showTag={shouldShowTopTag} productTypeName={p.topTagText || p.productTypeName} bottomTag={p.bottomTag} img={p.frontImg}/>
      <View className="right-container">
        <Title title={p.productName}/>
        <Remark displayScore={p.displayScore} score={p.score || ''} soldInfo={p.soldInfo} recommendReason={p.recommendReason}/>
        <Text x-if={p.areaName} numberOfLines={1} className="location">
          {p.areaName}
        </Text>
        {p.privilegeList.map(item => {
            return <Privilege label={item.label} desc={item.desc}/>;
        })}
        <Button actualPrice={p.actualPrice} originalPrice={p.originalPrice} reducedPrice={p.saveMoneyTag} buyText={p.buyText} averagePrice={p.averagePrice}/>
      </View>
    </View>;
}
export default memo(Card);
